import React from 'react'
import {Link, Redirect} from 'react-router-dom'
import CartItem from './CartItem'
import classes from './Cart.module.css';
import{emptyCart} from './CartHelpers';


export default function CartList({value}) {
    const subTotal=value.map(pro=>pro.count*pro.price).reduce((total,cur)=>total+cur);
  return (
    <div className={`container text-center mb-5 ${classes.Container}`}>
        <div className="row pt-2">
            <div className="col-10  mx-auto col-lg-2 d-none d-xl-block">
                <p className="text-uppercase">SẢN PHẨM</p>
            </div>
            <div className="col-10 mx-auto col-lg-2 d-none d-xl-block">
                <p className="text-uppercase">TÊN SẢN PHẨM</p>
            </div>
            <div className="col-10 mx-auto col-lg-2 d-none d-xl-block">
                <p className="text-uppercase">GIÁ</p>
            </div>
            <div className="col-10 mx-auto col-lg-2 d-none d-xl-block">
                <p className="text-uppercase">SỐ LƯỢNG</p>
            </div>
            <div className="col-10 mx-auto col-lg-2 d-none d-xl-block">
                <p className="text-uppercase">XÓA</p>
            </div>
            <div className="col-10 mx-auto col-lg-2 d-none d-xl-block">
                <p className="text-uppercase">TỔNG CỘNG</p>
            </div>
        </div>
        <hr/>
       {
           value.map(item=> {
               return <CartItem key={item._id} product={item}/>
           })
       }
       <hr/>
       <div className="row">
                <div className="col-10 mt-2 ml-sm-5 ml-md-auto col-sm-8 text-capitalize text-right">
                   
                    <h5>
                        <span className="text-title mr-1">
                        Tổng tiền: 
                        </span>
                        <strong>{subTotal+",000"}VND</strong>
                    </h5>
                    <h5>
                        <span className="text-title mr-1">
                        Tổng cộng: 
                        </span>
                        <strong>{subTotal+",000"}VND</strong>
                    </h5>
                    <Link to="/">
                        <button 
                        className="btn btn-outline-danger text-uppercase mb-3 mr-2"
                        type="button"
                        onClick={()=>emptyCart(()=><Redirect to="/"/>)}>
                            Hủy
                        </button>
                    </Link>
                    <Link to="/checkout">
                        <button 
                        className="btn btn-outline-success text-uppercase mb-3  "
                        type="button"
                        >
                            THANH TOÁN
                        </button>
                    </Link>
                </div>
            </div>
    </div>
  )
}